import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { SPONSORS } from "@/lib/sponsors";

const bands = [
  { label: "Pre K", path: "/preksessions", bg: "#F6B829" },
  { label: "K-2", path: "/k2sessions", bg: "#145261" },
  { label: "3-5", path: "/sessions35", bg: "#541011" },
  { label: "6-8", path: "/sessions68", bg: "#092936" },
  { label: "9-12", path: "/sessions912", bg: "#F6B829" },
];

export default function GradeBandButtons() {
  return (
    <section className="mt-6" data-testid="grade-band-buttons">
      <p className="text-xs font-bold tracking-widest text-muted-foreground uppercase mb-3">
        Select Your Grade
      </p>
      <div className="grid grid-cols-3 md:grid-cols-5 gap-3">
        {bands.map(({ label, path, bg, text }, i) => (
          <motion.div
            key={label}
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.05 * i }}
          >
            <Link
              to={path}
              data-testid={`grade-band-${label.toLowerCase().replace(/[^a-z0-9]/g, "")}`}
              className="rounded-xl p-6 flex flex-col items-center justify-center text-center hover:opacity-90 transition-opacity"
              style={{ backgroundColor: bg, color: text || "#ffffff" }}
            >
              <span className="font-bold text-2xl">{label}</span>
            </Link>
          </motion.div>
        ))}
      </div>
      <p className="text-foreground text-sm mt-3 leading-relaxed">
        *If you teach grades 2 and 3, 5 and 6, or across multiple grades, choose a grade.
      </p>

      <motion.div
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="mt-4"
      >
        <Link
          to="/otherstaff"
          data-testid="other-staff-btn"
          className="rounded-xl p-6 flex flex-col items-center justify-center text-center hover:opacity-90 transition-opacity"
          style={{ backgroundColor: "#145261", color: "#ffffff" }}
        >
          <span className="font-bold text-2xl">Other Staff</span>
        </Link>
      </motion.div>

      <div className="mt-6 text-center">
        <Link
          to="/resources#sponsors"
          data-testid="our-sponsors-link"
          className="block group"
        >
          <p className="text-sm font-medium text-muted-foreground group-hover:text-foreground underline underline-offset-4 transition-colors">
            Thank you to our Conference Partners
          </p>
          <div className="mt-4 flex items-center justify-center gap-4 sm:gap-6 flex-wrap">
            {SPONSORS.map((s) => (
              <div
                key={s.name}
                className="bg-white rounded-md p-1.5 flex items-center justify-center h-10 w-20 sm:h-12 sm:w-24"
                data-testid="home-sponsor-icon"
              >
                <img
                  src={s.logo}
                  alt={s.name}
                  style={s.scale ? { transform: `scale(${s.scale})` } : undefined}
                  className="max-h-full max-w-full object-contain"
                />
              </div>
            ))}
          </div>
        </Link>
      </div>
    </section>
  );
}
